export function isMobile() {
    const userAgent = navigator.userAgent;
    const mobileDevices = [
      /android/i,
      /webos/i,
      /iphone/i,
      /ipad/i,
      /ipod/i,
      /blackberry/i,
      /windows phone/i,
    ];
    return mobileDevices.some((device) => userAgent.match(device));
  }

  export const getPropsFromUrl = (location: string, separator: string) => {
    const search = location.split(separator);
    const newFilters = Object.assign({}) as any;
    search.forEach((value: any) => {
      if (value !== "") {
        const values = value.split("=");
        if (values[0] === "page") newFilters[values[0]] = +values[1] - 1;
        else
          newFilters[values[0]] = !isNaN(+values[1]) ? +values[1] : values[1];
        if (values[1] === "null") newFilters[values[0]] = null;
      }
    });
    return newFilters;
  };